// src/pages/Privacy.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './style/CGVCGU.css';

function Privacy() {
  const { t } = useTranslation();
  const sections = t('privacy.sections', { returnObjects: true });

  return (
    <div className="terms-page">
      <div className="terms-box">
        <h1>{t('privacy.title')}</h1>
        <p><em>{t('privacy.lastUpdate')}</em></p>

        {Object.keys(sections).map((key) => (
          <section key={`privacy-${key}`}>
            <h2>{sections[key].title}</h2>
            {Array.isArray(sections[key].text) ? (
              <ul>
                {sections[key].text.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            ) : (
              <p>{sections[key].text}</p>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}

export default Privacy;
